"use server";
import { z } from "zod";
import { redirect } from "next/navigation";
import { cookies } from "next/headers";
import { supabaseServer } from "@/lib/auth/supabase";
export type LoginState = { error?: string };
export async function signIn(
  _state: LoginState,
  form: FormData,
): Promise<LoginState> {
  const input = z
    .object({ email: z.email().max(254), password: z.string().min(1).max(256) })
    .safeParse({ email: form.get("email"), password: form.get("password") });
  if (!input.success) return { error: "Enter your email and password." };
  const supabase = await supabaseServer();
  const { error } = await supabase.auth.signInWithPassword(input.data);
  if (error)
    return {
      error: "We could not sign you in. Check your email and password.",
    };
  (await cookies()).delete("prnflow_organization");
  redirect("/auth/choose");
}
export async function signOut() {
  const supabase = await supabaseServer();
  await supabase.auth.signOut();
  (await cookies()).delete("prnflow_organization");
  redirect("/login");
}
